const getRadialGradientCss = hexValue => {
  if (hexValue) {
    return `background-image: radial-gradient(ellipse at center, ${hexValue}, ${hexValue}00);`;
  } else {
    return '';
  }
};

export default getRadialGradientCss;
